/*
Общий корень для браузера и сервера.

Дерево обязано совпадать до последнего узла: если разметка с сервера разойдётся
с первым рендером в браузере, React выбросит присланное и нарисует всё заново —
и серверный рендеринг перестанет что-либо ускорять. Поэтому провайдеры
описаны здесь один раз, а не дублируются в двух точках входа.
*/
import './styles/tokens.css';
import './styles/base.css';
import './styles/animations.css';
import './styles/components.css';
import './styles/layout.css';
import './styles/pages.css';
import './styles/admin.css';

import App from './App.jsx';
import { ToastProvider } from './store/ToastContext.jsx';
import { StoreProvider } from './store/StoreContext.jsx';
import { UIProvider } from './store/UIContext.jsx';

export default function Root({ initial = null }) {
  return (
    <ToastProvider>
      <StoreProvider initial={initial}>
        <UIProvider>
          <App />
        </UIProvider>
      </StoreProvider>
    </ToastProvider>
  );
}
